import { useState } from "react";

export const useErrorNotification = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const showError = (error: any) => {
    const message = error?.message || error?.toString() || "An unexpected error occurred";
    setErrorMessage(message);
  };

  const clearError = () => {
    setErrorMessage(null);
  };

  return {
    errorMessage,
    showError,
    clearError,
  };
}; 